import store from '../store'

const PersonelsUtils = {
    CheckEmployementDate() {
        var settings = store.state.settings.settings
        //console.log(settings);
        if (settings.EnableAccessAfterDay) {
            try {
                var personelDetail = store.state.personel.personelDetail

                var moment = require("jalali-moment");
                var workBeginDate = moment(personelDetail.WorkBeginDate, "jYYYY/jMM/jDD").locale("fa")
                var today = moment().locale("fa")

                var diff = today.diff(workBeginDate, 'days')
                
                if (diff >= Number(settings.EnableAccessAfterDay)) {
                    return true
                } else {
                    return false
                }
            } catch {
                return false
            }
        } else {
            return true
        }
    },
}

export default PersonelsUtils;